// extracted by mini-css-extract-plugin
export default {"bar":"ProgressBar_bar__Eb8K1","bar_inner":"ProgressBar_bar_inner__c4lw3"};